export default {
	FOOD_PERMIT: 'Food permit',
};
